<template>
  <div class="input-change-password">
    <slot name="txtBefore">
      <h2>Passwort</h2>
      <p>Ändern Sie Ihr Passwort hier.</p>
    </slot>
    <b-form
      class="change-password-input-form"
      :id="'form' + _uid"
      :state="isValid('oldPassword', 'newPassword', 'newPasswordRepeat')">
      <b-form-group class="old-password-group">
        <b-row>
          <b-col md="" sm="12" class="label">
            <label class="mandatory d-inline-block">
              <slot name="oldPasswordLabelTxt">Altes Passwort</slot>
            </label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="oldPassword"
              type="password"
              required
              @input="$v.oldPassword.$touch"
              :state="isValid('oldPassword')"
              v-model="oldPassword"
            ></b-form-input>
            <b-form-invalid-feedback id="old-password-live-feedback">
              <slot v-if="!$v.password.isValid" name="oldPasswordLiveFeedback">
                Passwort muss 6-8 Zeichen lang sein.
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="password-group">
        <b-row>
          <b-col md="" sm="12" class="label">
            <label class="mandatory d-inline-block">
              <slot name="passwordLabelTxt">Neues Passwort</slot>
            </label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="password"
              type="password"
              required
              @input="$v.password.$touch"
              :state="isValid('password')"
              v-model="password"
            ></b-form-input>
            <b-form-invalid-feedback id="password-live-feedback">
              <slot v-if="!$v.password.isValid" name="passwordLiveFeedback">
                Passwort muss 6-8 Zeichen lang sein.
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="password-repeat-group">
        <b-row>
          <b-col md="" sm="12" class="label">
            <label class="mandatory d-inline-block">
              <slot name="passwordRepeatLabelTxt">Passwort wiederholen</slot>
            </label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-input
              name="password-repeat"
              type="password"
              required
              @input="$v.passwordRepeat.$touch"
              :state="isValid('passwordRepeat')"
              v-model="passwordRepeat"
              aria-describedby="password-repeat-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="password-repeat-live-feedback">
              <slot v-if="$v.passwordRepeat.sameAsPassword === false" name="passwordRepeatLiveFeedback">
                Passwort nicht identisch
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
    <Stepper
      @prev="prev()"
      @next="next()"
      :disabled-next="$v.$invalid"
      :loading-next="loadingNext"
    >
      <template #btnNext><slot name="btnNext">ändern</slot></template>
      <template #btnPrev><slot name="btnPrev">zurück</slot></template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '../../../../../mixins/processSteps'
import Stepper from '../../../../generic/Stepper.vue'
import { mapActions, mapMutations } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import isValid from '../../../../../mixins/isValid'
import { BForm, BFormGroup, BFormInput, BRow, BCol, BFormInvalidFeedback } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'

export const stepName = 'input'

export default {
  name: 'InputChangePassword',
  data () {
    return {
      oldPassword: '',
      password: '',
      passwordRepeat: '',
      loadingNext: false
    }
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    Stepper
  },
  mixins: [
    validationMixin,
    isValid,
    processSteps(stepName, stepName, stepName) // do no jump by default. configure steps by props of processStep
  ],
  methods: {
    ...mapMutations('changePassword', [
      'changeStep'
    ]),
    ...mapActions('changePassword', [
      'changePassword'
    ]),
    next () {
      this.loadingNext = true
      this.changePassword({ changePasswordData: { oldPassword: this.oldPassword, password: this.password }, nextStep: this.nextStep })
        .then(() => {
          this.loadingNext = false
        }, () => {
          this.loadingNext = false
        })
    },
    prev () {
      this.newPassword = ''
      this.newPasswordRepeat = ''
      this.oldPassword = ''

      this.changeStep({ step: this.previousStep })
    }
  },
  validations () {
    return {
      oldPassword: {
        required
      },
      password: {
        required,
        passwordValidation: this.$config.validation.validatePassword // also test length
      },
      passwordRepeat: {
        required,
        sameAsPassword: sameAs(function () {
          return this.password
        })
      }
    }
  }
}
</script>
